/**
 * @file 长图文组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import {IS_BAIDU} from '@utils/detect';
import mountCard from '../mount-card';

export default class ImgText extends Component {
    static template = `
        <div class="img-text-wrap">
            <template s-for="item, index in data">
                <img s-if="item.type === 'img'"
                     src="{{item.data.src}}"
                     on-click="imgClick(index)" />
                <components-mount-card
                    class="mount-card"
                    s-if="IS_BAIDU && gemFrom !== 5 && item.type === 'goods'"
                    data="{{item}}"/>
                <template s-if="item.type === 'text'">
                    <p s-for="text in item.data">{{text}}</p>
                </template>
            </template>
            <div s-if="gemFrom === 5" class="tips">内容来自百家号</div>
        </div>
    `;
    static components = {
        'components-mount-card': mountCard
    };
    initData() {
        return {
            IS_BAIDU
        };
    }
    // 图片点击
    imgClick(index) {
        const contentData = this.data.get('data');
        const imglist = contentData.map(item => item.data.src).filter(item => item);
        const imgIndx = imglist.findIndex(src => src === contentData[index].data.src);
        this.fire('imgclick', {imgIndx, imglist});
    }
}
